import { httpV2 } from "../http.js";

const AutomationRulesService = {
  list: (params = {}) => httpV2.get("/automation-rules", { params }),
  get: (id) => httpV2.get(`/automation-rules/${id}`),
  create: (rule) => httpV2.post("/automation-rules", rule),
  update: (id, rule) => httpV2.put(`/automation-rules/${id}`, rule),
  remove: (id) => httpV2.delete(`/automation-rules/${id}`),
  setActive: (id, is_active) => httpV2.post(`/automation-rules/${id}/active`, { is_active }),
  listRuns: (id) => httpV2.get(`/automation-rules/${id}/runs`),
  reconcileReservation: (reservation_id, ruleId = null) => (
    httpV2.post(
      ruleId
        ? `/automation-rules/${ruleId}/reconcile-reservation`
        : "/automation-rules/reconcile-reservation",
      { reservation_id },
    )
  ),
  reenableWorkOrder: (workOrderId) => (
    httpV2.post(`/automation-rules/work-orders/${workOrderId}/reenable`)
  ),
};

export default AutomationRulesService;
